import { render, staticRenderFns } from "./kaliteDetail.vue?vue&type=template&id=1db6ecde&scoped=true&"
import script from "./kaliteDetail.vue?vue&type=script&lang=js&"
export * from "./kaliteDetail.vue?vue&type=script&lang=js&"
import style0 from "./kaliteDetail.vue?vue&type=style&index=0&id=1db6ecde&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db6ecde",
  null
  
)

export default component.exports